import React from "react";
import "./Title.css";

export type TitleSize = "small" | "medium" | "large" | "xl";
export type TitleAlignment = "left" | "center" | "right";

interface TitleProps {
    text: string;
    size?: TitleSize;
    align?: TitleAlignment;
    className?: string;
}

const Title: React.FC<TitleProps> = ({
    text,
    size = "medium",
    align = "left",
    className = "",
}) => {
    const titleClasses = `title-main title-${size} title-${align} ${className}`;

    return <h1 className={titleClasses}>{text}</h1>;
};

export default Title;
